/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import ChangeoverModel from 'uplisting-frontend/models/changeover';

interface IArgs {
  changeover: ChangeoverModel;
}

export interface ChangeoverHostSignature {
  Element: HTMLFormElement;

  Args: IArgs;
}

export default class UiChangeoverHostComponent extends Component<ChangeoverHostSignature> {
  @service notifications!: Services['notifications'];

  @action
  async handleSaveChangeover(): Promise<void> {
    try {
      await this.args.changeover.save();

      this.notifications.info('action_changeovers_host.notifications.save');
    } catch {
      this.notifications.error();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Changeover::Host': typeof UiChangeoverHostComponent;
  }
}
